<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      inline-message
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_fileDesc') || '文档说明'"
            prop="fileDesc"
          >
            <el-input
              v-model="formData.fileDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="listDoc">
            <el-upload
              drag
              action="#"
              multiple
              :file-list="formData.listDoc"
              :auto-upload="false"
              :on-change="onFileChange"
              :on-remove="onFileChange"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
                }}<em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    custFolderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { listDoc: [] },
      rules: {
        fileDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        listDoc: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onFileChange(files, fileList) {
      this.formData.listDoc = fileList
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const items = await this.uploadFiles(this.formData.listDoc)
      this.loadingClose()

      if (items.includes(null)) {
        this.$message.error(
          this.$l('tips_error_uploadDoc') || '文件上传失败，请联系管理员'
        )
        return
      }

      const listDoc = items.map((item) => ({
        ...item,
        fileDesc: this.formData.fileDesc,
      }))

      this.close()
      this.$emit('confirm', listDoc)
    },
    uploadFiles(listDoc) {
      if (!listDoc?.length) return Promise.resolve([])

      const uploadTask = listDoc.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
            fileSize: this.formatFileSize(file.size),
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    formatFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + 'KB'
      } else {
        return bytes + 'B'
      }
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => this.upload())
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
